import React from 'react';
import styles from './Calendar.module.css';

const DateCell = ({ date, isCurrentMonth, isStart, isEnd, isInRange, onClick }) => {
  let cellClass = styles.dateCell;
  if (!isCurrentMonth) cellClass += ` ${styles.otherMonth}`;
  if (isStart) cellClass += ` ${styles.startDate}`;
  if (isEnd) cellClass += ` ${styles.endDate}`;
  if (isInRange && !isStart && !isEnd) cellClass += ` ${styles.inRange}`;

  return (
    <div className={cellClass} onClick={() => onClick(date)}>
      <span className={styles.dateNumber}>{date.getDate()}</span>
    </div>
  );
};

export default DateCell;